import { StartRoutingMiniApps } from './core/helpers/dna';
import { Starter } from './core';
import { setupApp } from './shared';
import { setupLocales } from './core/lang/i18n';
import { StarterUtils } from './core/starter';

import * as serviceWorker from './serviceWorker';

// Подключение файла-манифеста
// eslint-disable-next-line @typescript-eslint/no-var-requires
const manifest = {
    ...require('./apps.json'),
    ...require('./apps.geograffee.json'),
};

/**
 * Настройка языковых пакетов
 */
// eslint-disable-next-line @typescript-eslint/no-var-requires
setupLocales(
    require('./locales/en.json'),
    require('./locales/ru.json'),
    require('./locales/kz.json'),
    require('./locales/tr.json'),
    require('./locales/zh.json'),
).then(
        () => {
    // Сначала настроим язык приложения, а потом запустим движок
    // Это как загрузка ресурсов

    /**
     * Запуск роутинга по мини-приложениям
     */
    StartRoutingMiniApps(manifest, (miniApp) => {
        if (miniApp) {
            // Приложение успешно найдено
            Starter(miniApp, {
                async beforeStart() {
                    // Данный метод вызывается до запуска стартера

                    // Настройка приложения
                    setupApp();
                    return;
                },
            }).then();
        } else {
            // Приложение не найдено - отображаем ошибку на чистом HTML,
            // ведь React еще не начал свою работу :)
            StarterUtils.writeAppNotFoundMessage();
        }
    });
});

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();import { StartRoutingMiniApps } from './core/helpers/dna';
import { Starter } from './core';
import { setupApp } from './shared';
import { setupLocales } from './core/lang/i18n';
import { StarterUtils } from './core/starter';

import * as serviceWorker from './serviceWorker';

// Подключение файла-манифеста
// eslint-disable-next-line @typescript-eslint/no-var-requires
const manifest = {
    ...require('./apps.json'),
    ...require('./apps.geograffee.json'),
};

/**
 * Настройка языковых пакетов
 */
// eslint-disable-next-line @typescript-eslint/no-var-requires
setupLocales(
    require('./locales/en.json'),
    require('./locales/ru.json'),
    require('./locales/kz.json'),
    require('./locales/tr.json'),
    require('./locales/zh.json'),
).then(
        () => {
    // Сначала настроим язык приложения, а потом запустим движок
    // Это как загрузка ресурсов

    /**
     * Запуск роутинга по мини-приложениям
     */
    StartRoutingMiniApps(manifest, (miniApp) => {
        if (miniApp) {
            // Приложение успешно найдено
            Starter(miniApp, {
                async beforeStart() {
                    // Данный метод вызывается до запуска стартера

                    // Настройка приложения
                    setupApp();
                    return;
                },
            }).then();
        } else {
            // Приложение не найдено - отображаем ошибку на чистом HTML,
            // ведь React еще не начал свою работу :)
            StarterUtils.writeAppNotFoundMessage();
        }
    });
});

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();